const SORT_DIRECTION = {
	ASC: 'asc',
	DESC: 'desc',
} as const

const SORT_DIRECTIONS = [SORT_DIRECTION.ASC, SORT_DIRECTION.DESC] as const

type SortDirection = (typeof SORT_DIRECTIONS)[number]

type Sort<TField extends string> = {
	readonly field: TField
	readonly direction: SortDirection
}

const ISSUE_SORT_FIELDS = ['position', 'title', 'status', 'priority', 'size', 'created', 'updated'] as const
const ENTRY_SORT_FIELDS = ['title', 'slug', 'created', 'updated'] as const
const PLAN_SORT_FIELDS = ['title', 'status', 'created', 'updated'] as const
const TICKET_SORT_FIELDS = ['title', 'status', 'priority', 'created', 'updated'] as const
// Logs carry neither a title nor a slug, so only the dates sort them.
const LOG_SORT_FIELDS = ['created', 'updated'] as const
const DOC_SORT_FIELDS = ['title', 'slug', 'created', 'updated'] as const

type IssueSortField = (typeof ISSUE_SORT_FIELDS)[number]
type EntrySortField = (typeof ENTRY_SORT_FIELDS)[number]
type PlanSortField = (typeof PLAN_SORT_FIELDS)[number]
type TicketSortField = (typeof TICKET_SORT_FIELDS)[number]
type LogSortField = (typeof LOG_SORT_FIELDS)[number]
type DocSortField = (typeof DOC_SORT_FIELDS)[number]

export {
	DOC_SORT_FIELDS,
	ENTRY_SORT_FIELDS,
	ISSUE_SORT_FIELDS,
	LOG_SORT_FIELDS,
	PLAN_SORT_FIELDS,
	SORT_DIRECTION,
	SORT_DIRECTIONS,
	TICKET_SORT_FIELDS,
}
export type {
	DocSortField,
	EntrySortField,
	IssueSortField,
	LogSortField,
	PlanSortField,
	Sort,
	SortDirection,
	TicketSortField,
}
